import { useState }         from 'react';
import LIVR                 from 'livr';

import api                  from '../../../../../singleton/api.js';

const validator = new LIVR.Validator({
    email : [ 'required', 'email' ]
});

function useSubscribeBlock(captchaRef) {
    const [ email, setEmail ] = useState('');
    const [ errors, setErrors ] = useState({});
    const [ isLoading, setLoading ] = useState(false)
    
    function handleChange(e) {
        const value = e.target.value;
        
        setEmail(value)

        setErrors({ email: '' })
    }

    async function handleSubscribe() {
        const validData = validator.validate({ email });

        if (validData) {
            setLoading(true)
            const captchaKey = await captchaRef.current.executeAsync();
            try {
                const params = {
                    captchaKey
                };
                const payload = {
                    email,
                    newsSubscriptionType : 'ALL'
                };

                await api.account.subscribe(payload, params);
                setEmail('');
            } catch(err) {
                console.log(err)
            } finally {
                setLoading(false)
            }
        } else {
            const err = validator.getErrors();

            setErrors(err);
        }
    }

    return {
        email,
        errors,
        handleChange,
        handleSubscribe,
        isLoading
    };
}

export default useSubscribeBlock;
